type CheckoutPrefill = {
  email?: string;
  promoCode?: string;
};

const normalizeEmail = (value: string | null): string | undefined => {
  if (!value) {
    return undefined;
  }

  const trimmed = value.trim().toLowerCase();
  if (!trimmed || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
    return undefined;
  }

  return trimmed;
};

const normalizePromoCode = (value: string | null): string | undefined => {
  if (!value) {
    return undefined;
  }

  const trimmed = value.trim().toUpperCase();
  if (!trimmed || !/^[A-Z0-9_]+$/.test(trimmed)) {
    return undefined;
  }

  return trimmed;
};

export const resolveCheckoutPrefillFromUrl = (
  urlLike: URL | string = window.location.href
): CheckoutPrefill => {
  const url = typeof urlLike === "string" ? new URL(urlLike) : urlLike;

  const email = normalizeEmail(url.searchParams.get("email"));
  const promoCode = normalizePromoCode(
    url.searchParams.get("promo") ?? url.searchParams.get("promo_code")
  );

  return {
    ...(email ? { email } : {}),
    ...(promoCode ? { promoCode } : {})
  };
};